module.exports = __webpack_public_path__ + "img/4.80b59a1f.png";